const t = {
  name: "ZoomOut",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22,15H10v2h12V15z"/>
		<path class="st0" d="M0,16C0,7.2,7.2,0,16,0c8.8,0,16,7.2,16,16c0,3.3-1,6.4-2.8,9L40,35.8L35.8,40L25,29.2C22.4,31,19.3,32,16,32
			C7.2,32,0,24.8,0,16z M16,2C8.3,2,2,8.3,2,16c0,7.7,6.3,14,14,14c7.7,0,14-6.3,14-14C30,8.3,23.7,2,16,2z M26.6,28l9.2,9.2
			l1.4-1.4L28,26.6C27.6,27.1,27.1,27.6,26.6,28z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as ZoomOut
};
